export const ROLE_BASED_DEFAULT_ROUTE = {
  SUPER_ADMIN: "/super-admin/approval-letters",
  ADMIN: "/admin/dashboard",
  CHANNEL_PARTNER: "/channel-partner/dashboard", // for now default page
  TRAINER: "/instructor/dashboard", // for now default page
};

export const REGEX = {
  // Email regex  /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
  EMAIL_REGEX:
    /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/,

  // Regex that accepts only digits
  ONLY_DIGITS_REGEX: /^[0-9]*$/,

  // Phone number
  PHONE_NO_REGEX: /^[7896]\d{9}$/, // /^\d{10}$/,

  // Regex that matches the entire string only if it contains only digits and at least one digit.
  OTP_STRING_REGEX: /^\d+$/,

  // Regex that accepts only alphabets in both small and capital case and spaces
  ONLY_ALPHABETS_REGEX: /^[a-zA-Z ]{2,50}$/,

  // Password regex
  PASSWORD_REGEX:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=[\]{}|;:'",.<>?/`~.]{6,32}$/,

  // Letters, numbers, spaces, and common special symbols (- . , & /)
  ALPHABETS_NUM_SPACE_SPECIAL_SYMBOLS_ALLOWED: /^[a-zA-Z0-9\s\-.,&/]+$/,

  // GST Number: 2 digits state code + 10 alphanumeric PAN card + 1 entity + 1 Z + 1 checksum //
  GST_REGEX: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,

  // PAN Number: 5 letters + 4 digits + 1 letter //AAACH2702H {10}
  PAN_REGEX: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,

  INLINE_PLACEHOLDER: /{{\s*(\w+)\s*}}/g,

  VOLTAGE_REGEX: /^(?:(?:[1-9]\d?|[1-3]\d{2})(?:\.\d+)?|400(?:\.0+)?)\s*KV$/i,
  //[1-9] [10-99] [100-399] decimal is optional EXACTLY 400.00 only  will allow

  AADHAAR_REGEX: /^[2-9]\d{3}\s\d{4}\s\d{4}$/,   //{12}

  VOTER_ID_REGEX: /^[A-Z]{3}[0-9]{7}$/,   //ABC1234567  first three letters like ABD then 7 digit {10}

  PASSPORT_REGEX: /^[A-PR-WY][0-9]{7}$/,
  //QXZ are not allowed or use  1st letter uppercase and next exactly 7 digit {8}

  TOOLS_QTY_REGEX: /^\d+\s*(Nos|Set|Box each|Nos each|Set each|Item|Items)$/i,
  //accept Nos | Set if ? 0 or 1 space only * multi space case insensitive

  TRAINEE_NAME_REGEX: /^[a-zA-Z. ]+$/,

  DOB_REGEX: /^\d{4}-\d{2}-\d{2}$/,

  //to match the digit regex while adding edit in instrutor experience
  EXTRACT_DIGITS_REGEX: /\d+/,

  DIGIT_KEY_REGEX: /^[0-9]$/,// Single digit


  // Pincode regex: 6 digits allow only
  PIN_CODE_REGEX: /^[0-9]{6}$/,

  ALPHANUMERIC_SPACE_REGEX: /^[a-zA-Z0-9 ]+$/,

  VALID_URL_REGEX: /^https?:\/\//i,

  // Validates Microsoft Teams and Microsoft related meeting links
  MS_TEAMS_LINK_REGEX: /^https:\/\/(?:teams\.microsoft\.com|teams\.live\.com)\/(?:l|meet)\/[^\s\?]+(?:\?[^\s]*)?$/i,

  // Validates that the city name contains only letters and spaces
  CITY_REGEX: /^[A-Za-z ]+$/,
};

export const MAX_FILE_SIZE = 15 * 1024 * 1024; //15 mb

export const ALLOWED_ROLES = ["SUPER_ADMIN", "ADMIN", "CHANNEL_PARTNER", "TRAINER"];

export const OTP_TIMER = 300;

export const LOGIN_TYPE = {
  1: "EMAIL_PASSWORD",
  2: "MOBILE_PASSWORD",
  3: "EMAIL_OTP",
  4: "MOBILE_OTP",
};

export const DEFAULT_RECORDS_PER_PAGE = 10;

export const COLOR_HEX = {
  INVALID_INPUT_BORDER: "#FB6E40", // // red color for invalid input border
  VALID_INPUT_BORDER: "#DEE2E6", // // select input and placeholder color
  SELECT_PLACEHOLDER_COLOR: "#ADB5BD", // // select input and placeholder color
};

export const SELECT_CUSTOM_STYLES = {
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "2.938rem",
    fontSize: "0.875rem",
    borderColor: state.selectProps.className?.includes("is-invalid")
      ? COLOR_HEX.INVALID_INPUT_BORDER
      : state.isFocused
        ? "#5e72e4" // COLOR_HEX.VALID_INPUT_BORDER
        : COLOR_HEX.VALID_INPUT_BORDER,
    boxShadow: state.isFocused ? "0 0 0 0 rgba(0,123,255,.25)" : "none", //0 0 0 1px #DEE2E6
    "&:hover": {
      borderColor: state.selectProps.className?.includes("is-invalid")
        ? COLOR_HEX.INVALID_INPUT_BORDER
        : state.isFocused ? "#5e72e4" : COLOR_HEX.VALID_INPUT_BORDER, // COLOR_HEX.VALID_INPUT_BORDER
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 9px", //"0 18px",
    fontSize: "0.875rem", //"0.7500000025rem",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "33px",
    paddingTop: "0.5rem",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    marginBottom: "0.063rem", //1px
  }),
  menu: (provided) => ({
    ...provided,
    fontSize: "0.875rem",
    zIndex: 9999
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#525F7F",
    fontWeight: "400",
    fontSize: "0.875rem",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: COLOR_HEX.SELECT_PLACEHOLDER_COLOR,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: "15rem",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

// fixed width Custom style for react select
export const fixedWidthCustomStyle = (width = "15rem") => {
  const isMobile = window.innerWidth <= 768;
  const responsiveWidth = isMobile ? "100%" : width;

  return {
    container: (provided) => ({
      ...provided,
      width: responsiveWidth,
      minWidth: responsiveWidth,
      maxWidth: responsiveWidth,
      flex: `0 0 ${responsiveWidth}`,
    }),

    control: (provided, state) => ({
      ...provided,
      width: "100%",
      minWidth: 0,
      minHeight: "2.73rem",
      height: "2.73rem",
      borderRadius: "0.25rem",
      borderColor: "#dee2e6",
      color: "#222a42",
      boxShadow: state.isFocused
        ? "0 0 0 0 rgba(0,123,255,.25)"
        : "none",

      "&:hover": {
        borderColor: state.isFocused
          ? "#5e72e4"
          : "#d0d7de",
      },
    }),

    valueContainer: (provided) => ({
      ...provided,
      minWidth: 0,
      overflow: "hidden",
      padding: "0 1.125rem",
      fontSize: "0.7500000025rem",
    }),

    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),

    indicatorsContainer: (provided) => ({
      ...provided,
      flexShrink: 0,
      height: "2.0625rem",
      marginTop: "0.3rem",
    }),

    indicatorSeparator: (provided) => ({
      ...provided,
      flexShrink: 0,
      marginBottom: "0.063rem",
      marginTop: 0,
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#ADB5BD",
      fontSize: "0.875rem",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#525F7F",
      fontWeight: "400",
      fontSize: "0.875rem",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }),

    option: (provided) => ({
      ...provided,
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "anywhere",
      lineHeight: "1.25rem",
      paddingTop: "0.5rem",
      paddingBottom: "0.5rem",
    }),
  }
};

export const getCourseStatusColor = (status) => {
  switch (status) {
    case "PUBLISHED":
      return "success";
    case "DRAFT":
      return "danger";
    case "READY_TO_PUBLISH":
      return "primary";
    default:
      return "secondary";
  }
};

export const LessonTypeColor = {
  IMAGE: "success",
  DOCUMENT: "warning",
  SHEET: "danger",
  VIDEO: "info",
  URL: "secondary",
};

export const MAX_THUMBNAIL_IMG_SIZE = 15 * 1024 * 1024; // 10MB

export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const MAX_DOCUMENT_SIZE = 15 * 1024 * 1024; // 15 mb

export const MAX_PHOTO_SIZE = 5 * 1024 * 1024; // 5 mb

export const MAX_LESSON_SIZE = 1024 * 1024 * 1024;

export const MAX_DESCRIPTION_LENGTH = 2000;

export const PREVIEW_LIMIT = 350;

export const OFFICE_PREVIEW_URL = "https://view.officeapps.live.com/op/embed.aspx?src=";

export const MAX_REVIEW_LENTGH = 150;